import 'Components/01-components/menu/tabs.css';
import { CollapsibleMenuBlock, CollapsibleSubmenu } from 'Components/01-components/menu';

(function (Drupal) {
  Drupal.behaviors.wsuBaseMenus = {
    attach: function (context, settings) {
      context.querySelectorAll('.menu--sidebar-tree > li').forEach(CollapsibleSubmenu);
      context.querySelectorAll('.main__sidebar > nav').forEach(CollapsibleMenuBlock);
    }
  };
}(Drupal));
